import {
  FrontendAddonRaw,
  FrontendAddonTargetVersionRaw,
} from "@/domain/FrontendAddon";
import { OrganizationRaw } from "@/domain/Organization";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlFrontendMasters = "admin/frontend_masters";

export const getAdminFrontendMaster = async ({
  frontendAddonId,
}: {
  frontendAddonId: FrontendAddonRaw["id"];
}): Promise<OrganizationRaw[]> => {
  const response = await API_CLIENT.get(
    `${apiUrlFrontendMasters}/${frontendAddonId}`
  );
  return response.data.items;
};

export const getAdminFrontendMasterOrgs = async ({
  frontendAddonId,
}: {
  frontendAddonId: FrontendAddonRaw["id"];
}): Promise<OrganizationRaw[]> => {
  const response = await API_CLIENT.get(
    `${apiUrlFrontendMasters}/${frontendAddonId}/orgs`
  );
  return response.data.items;
};

export const postAdminFrontendMasterAssign = async ({
  organizationId,
  frontendAddonId,
  targetVersion,
}: {
  organizationId: string;
  frontendAddonId: FrontendAddonRaw["id"];
  targetVersion: FrontendAddonTargetVersionRaw;
}): Promise<void> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);

  await API_CLIENT.post(
    `${apiUrlFrontendMasters}/${frontendAddonId}/enable`,
    targetVersion,
    {
      ...apiOrganizationIdParams,
    }
  );
};

export const postAdminFrontendMasterUnassign = async ({
  organizationId,
  frontendAddonId,
}: {
  organizationId: string;
  frontendAddonId: FrontendAddonRaw["id"];
}): Promise<void> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);

  await API_CLIENT.post(
    `${apiUrlFrontendMasters}/${frontendAddonId}/disable`,
    null,
    {
      ...apiOrganizationIdParams,
    }
  );
};
